export default __webpack_public_path__ + "static/media/logo_mini_supply.df2c0f63.png";